import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(props, _ref) {
    var $, $on, $f7, $f7router, $f7route, $update, usr, avatar, userLoggedIn, viewTutors, pin, keynumber, safeAttempts, f7, openFingerprint, setPIN, recoveryPIN, actionSettings, savePIN, setSafe, safeCancel, calcAge, updateForm, checkData, checkParentsAndTutor, deleteAvatar, rotateAvatar, storeAvatar, setAvatar, qrscan, save;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            $ = _ref.$, $on = _ref.$on, $f7 = _ref.$f7, $f7router = _ref.$f7router, $f7route = _ref.$f7route, $update = _ref.$update;
            console.log('ME');
            /*
             * Valori iniziali
             */

            usr = {}, pin = [], keynumber = [], safeAttempts = 3, f7 = $f7;
            _context13.next = 5;
            return myApp.user();

          case 5:
            usr = _context13.sent;
            usr.data = usr.data || {};
            _context13.next = 9;
            return myStorage.get(usr.data.avatar);

          case 9:
            _context13.t1 = _context13.sent;

            if (_context13.t1) {
              _context13.next = 12;
              break;
            }

            _context13.t1 = usr.data.avatar;

          case 12:
            _context13.t0 = _context13.t1;

            if (_context13.t0) {
              _context13.next = 15;
              break;
            }

            _context13.t0 = 'static/avatar.svg';

          case 15:
            avatar = _context13.t0;
            userLoggedIn = myApp.userLoggedIn || false; //const data_type = $f7.device.cordova ? 'text' : 'date';
            //let data_value = $f7.device.cordova ? '' : (usr.data.birthdate || '').substring(0,10);

            /*
             * Evento di pagina: https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Aggiorna user
             * Imposta tastiera numerica PIN
             */

            $on('pageMounted', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return myApp.server.getJSON('user/me');

                    case 3:
                      usr = _context.sent;
                      console.log(usr);
                      _context.next = 7;
                      return myApp.user(usr);

                    case 7:
                      _context.next = 9;
                      return myStorage.get(usr.data.avatar);

                    case 9:
                      _context.t1 = _context.sent;

                      if (_context.t1) {
                        _context.next = 12;
                        break;
                      }

                      _context.t1 = usr.data.avatar;

                    case 12:
                      _context.t0 = _context.t1;

                      if (_context.t0) {
                        _context.next = 15;
                        break;
                      }

                      _context.t0 = avatar;

                    case 15:
                      avatar = _context.t0;
                      $update();
                      _context.next = 22;
                      break;

                    case 19:
                      _context.prev = 19;
                      _context.t2 = _context["catch"](0);
                      console.log(_context.t2);

                    case 22:
                      _context.prev = 22;
                      $('#sex').val(usr.data.sex);
                      calcAge();
                      /* if ($f7.device.cordova) {
                       $f7.calendar.create({
                       inputEl: '#birthdate',
                       value: [usr.data.birthdate || new Date()],
                       toolbarCloseText: lng.insert + ' ' + lng.birthdate,
                       cssClass: 'color-theme-secondary',
                       closeOnSelect: false,
                       maxDate: new Date(),
                       sheetSwipeToClose: false,
                       backdrop: true,
                       on: {
                       close() {
                       let a = this.getValue();
                       updateForm({target: {id: 'birthdate', value: a[0].toISOString()}});
                       }
                       }
                       });
                       } // */

                      return _context.finish(22);

                    case 26:
                      $('.pin').on('click', function (ev) {
                        setPIN($(ev.target).data('number'));
                      });
                      $('.safe').on('click', function (ev) {
                        setSafe($(ev.target).data('number'));
                      });

                    case 28:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 19, 22, 26]]);
            })));
            /*
             * Evento di pagina: pageBeforeIn
             * https://framework7.io/docs/router-component.html#component-page-events
             * 
             * Imposta o controlla PIN
             */

            $on('pageBeforeIn', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!usr.data.pin) {
                        $f7.popup.open('.popup-pin', false);
                      } else if ($f7route.query.pin === 'yes' && !myApp.secureMode) {
                        $f7.popup.open('.popup-safe', false);
                        openFingerprint();
                      }

                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })));
            /**
             * Login con dati biometrici (Fingerprint / Analisi del viso)
             * 
             * Usa cordova-plugin-fingerprint-aio
             * cordova plugin add cordova-plugin-fingerprint-aio --variable FACEID_USAGE_DESCRIPTION="Per modificare i tuoi dati personali in sicurezza."
             * https://www.npmjs.com/package/cordova-plugin-ebw-fingerprint-aio
             * 0
             * @returns {undefined}
             */

            openFingerprint = function openFingerprint() {
              if ($f7.device.cordova) {
                var isAvailableSuccess = function isAvailableSuccess() {
                  Fingerprint.show({
                    description: lng.access_with_biometric_message
                  }, successCallback, function (errorCallback) {
                    return console.log(errorCallback);
                  });
                };

                var successCallback = function successCallback(res) {
                  myApp.enableSecure();
                  $('#safe-message').addClass('invisible');
                  $f7.popup.close('.popup-safe');
                  checkData();
                };

                Fingerprint.isAvailable(isAvailableSuccess, function () {
                  return console.log('Fingerprint not available');
                });
              }
            };
            /**
             * Imposta PIN
             * 
             * @param {type} number
             * @returns {undefined}
             */


            setPIN = function setPIN(number) {
              if (number === 'back' && pin.length) {
                pin.pop();
                $('.pin-char').text('');
              } else if (pin.length < 4 && number !== 'back') {
                pin.push(number);
              }

              if (pin.length === 4) {
                $('#pin-btn-next').removeClass('invisible');
              } else {
                $('#pin-btn-next').addClass('invisible');
              }

              pin.forEach(function (e, i) {
                $('#pin_' + i).text(e);
              });
            };

            recoveryPIN = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var phone, pin, url;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return myApp.server.authToken();

                      case 2:
                        phone = _context3.sent;
                        pin = usr.data.pin.join('');
                        url = 'https://webapp.doctorpass.it/auth/' + lng.key + '/doctorpass/' + encodeURIComponent(phone) + '/' + btoa(pin);

                        window.recoveryPinCallback = function (pin) {
                          return console.log(pin);
                        };

                        myApp.iab(url);

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function recoveryPIN() {
                return _ref5.apply(this, arguments);
              };
            }();
            /**
             * Apre Actions sheet
             * 
             * @returns {undefined}
             */


            actionSettings = function actionSettings() {
              $f7.actions.create({
                buttons: [[{
                  label: true,
                  text: lng.select_action
                }, {
                  text: lng.set_pin,
                  color: 'blue',
                  onClick: function onClick() {
                    $f7.popup.open('.popup-pin');
                  }
                }], [{
                  text: lng.cancel,
                  color: 'gray'
                }]]
              }).open();
            };
            /**
             * Salva PIN
             * 
             * @returns {undefined}
             */


            savePIN = /*#__PURE__*/function () {
              var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                var r, json;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!(pin.length < 4)) {
                          _context4.next = 2;
                          break;
                        }

                        return _context4.abrupt("return");

                      case 2:
                        usr.data.pin = pin;
                        $f7.preloader.show();
                        _context4.prev = 4;
                        _context4.next = 7;
                        return myApp.server.post('user/me', {
                          usr: usr.data
                        });

                      case 7:
                        r = _context4.sent;
                        _context4.next = 10;
                        return r.json();

                      case 10:
                        json = _context4.sent;

                        if (!r.ok) {
                          _context4.next = 18;
                          break;
                        }

                        _context4.next = 14;
                        return myApp.user(usr);

                      case 14:
                        $f7.popup.close('.popup-pin');
                        checkData();
                        _context4.next = 19;
                        break;

                      case 18:
                        $f7.dialog.alert(lng.error_message + ' <br/>' + r.status + ' ' + json.error.message);

                      case 19:
                        _context4.next = 24;
                        break;

                      case 21:
                        _context4.prev = 21;
                        _context4.t0 = _context4["catch"](4);
                        $f7.alertError(_context4.t0);

                      case 24:
                        _context4.prev = 24;
                        $f7.preloader.hide();
                        return _context4.finish(24);

                      case 27:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[4, 21, 24, 27]]);
              }));

              return function savePIN() {
                return _ref6.apply(this, arguments);
              };
            }();
            /**
             * Chiede e controlla PIN
             * 
             * @param {type} number
             * @returns {undefined}
             */


            setSafe = function setSafe(number) {
              if (!safeAttempts) return;

              switch (number) {
                case 'null':
                  break;

                case 'back':
                  if (keynumber.length) {
                    keynumber.pop();
                  }

                  break;

                default:
                  if (keynumber.length === 3) {
                    keynumber.push(number);
                    var ok = true;
                    usr.data.pin = usr.data.pin || [];
                    keynumber.forEach(function (e, i) {
                      if (e !== usr.data.pin[i]) ok = false;
                    });

                    if (ok) {
                      $('#safe-message').addClass('invisible');
                      myApp.enableSecure();
                      $f7.popup.close('.popup-safe');
                      checkData();
                    } else {
                      $('#safe-message').removeClass('invisible');
                      keynumber = [];
                      safeAttempts--;
                      $update();
                    }
                  } else {
                    keynumber.push(number);
                  }

              }

              $('.point').removeClass('point-fill');
              keynumber.forEach(function (e, i) {
                return $('.point-' + i).addClass('point-fill');
              });
            };
            /**
             * Annulla controllo PIN
             * 
             * @returns {undefined}
             */


            safeCancel = function safeCancel() {
              $f7router.back();
              $f7.popup.close('.popup-safe', false);
            };
            /*
             * Calcola l'età sulla base della data di nascita
             * @returns {undefined}
             */


            calcAge = function calcAge() {
              var birthdate = new Date(usr.data.birthdate);
              var datediff = new Date(Date.now() - birthdate.getTime());
              var age = Math.abs(datediff.getUTCFullYear() - 1970);
              viewTutors = age < 18;
              $update();
            };
            /*
             * Aggiorna user.data alla modifica di un campo
             */


            updateForm = function updateForm(e) {
              usr.data[e.target.id] = e.target.value;
              console.log(usr);
              checkParentsAndTutor();
            };

            checkData = function checkData() {
              var dataOk = true; // controlla dati richiesti

              myApp.userDataRequired.split(',').forEach(function (k) {
                if (!usr.data[k]) {
                  dataOk = false;
                }
              });

              if (!dataOk) {
                var msg = lng.me_create_children_message_2;
                $f7.dialog.alert(msg);
              }
            };
            /*
             * Imposta i valori required e validate ai campi parent1, parent2 e tutor
             * sulla base dei diversi valori
             * @returns {undefined}
             */


            checkParentsAndTutor = function checkParentsAndTutor() {
              calcAge();
              if (!viewTutors) return;

              if ($f7.input.validate('#parent1_name') && $f7.input.validate('#parent1_lastname') &&
              /*$f7.input.validate('#parent1_cf') &&*/
              $f7.input.validate('#parent2_name') && $f7.input.validate('#parent2_lastname')
              /*&& $f7.input.validate('#parent2_cf')*/
              ) {
                  $('#tutor_name').prop('required', false);
                  $('#tutor_name').prop('validate', false);
                  $('#tutor_lastname').prop('required', false);
                  $('#tutor_lastname').prop('validate', false); //$('#tutor_cf').prop('required', false);
                  //$('#tutor_cf').prop('validate', false);
                } else if ($f7.input.validate('#tutor_name') && $f7.input.validate('#tutor_lastname')
              /*&& $f7.input.validate('#tutor_cf')*/
              ) {
                  $('#parent1_name').prop('required', false);
                  $('#parent1_name').prop('validate', false);
                  $('#parent1_lastname').prop('required', false);
                  $('#parent1_lastname').prop('validate', false); //$('#parent1_cf').prop('required', false);
                  //$('#parent1_cf').prop('validate', false);

                  $('#parent2_name').prop('required', false);
                  $('#parent2_name').prop('validate', false);
                  $('#parent2_lastname').prop('required', false);
                  $('#parent2_lastname').prop('validate', false); //$('#parent2_cf').prop('required', false);
                  //$('#parent2_cf').prop('validate', false);
                } else {
                $('#tutor_name').prop('required', true);
                $('#tutor_name').prop('validate', true);
                $('#tutor_lastname').prop('required', true);
                $('#tutor_lastname').prop('validate', true); //$('#tutor_cf').prop('required', true);
                //$('#tutor_cf').prop('validate', true);

                $('#parent1_name').prop('required', true);
                $('#parent1_name').prop('validate', true);
                $('#parent1_lastname').prop('required', true);
                $('#parent1_lastname').prop('validate', true); //$('#parent1_cf').prop('required', true);
                //$('#parent1_cf').prop('validate', true);

                $('#parent2_name').prop('required', true);
                $('#parent2_name').prop('validate', true);
                $('#parent2_lastname').prop('required', true);
                $('#parent2_lastname').prop('validate', true); //$('#parent2_cf').prop('required', true);
                //$('#parent2_cf').prop('validate', true);
              }

              $update();
            };
            /*
             * Elimina avatar
             * @returns {undefined}
             */


            deleteAvatar = function deleteAvatar() {
              var old = usr.data.avatar;
              $f7.dialog.confirm(lng.delete_image_message, function () {
                usr.data.avatar = 'static/default/avatar.svg';
                save().then(function () {
                  avatar = usr.data.avatar;
                  $update();
                  myStorage.deleteItem(old);
                }).catch(function () {
                  return usr.data.avatar = avatar;
                });
              });
            };
            /**
             * Ruota avatar in senso antiorario di 90°
             * @returns {undefined}
             */


            rotateAvatar = /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                var old, data;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        $f7.preloader.show();
                        _context5.prev = 1;
                        old = usr.data.avatar;
                        _context5.next = 5;
                        return myApp.server.postJSON('user/me/avatar/rotate', {
                          src: usr.data.avatar,
                          children: null
                        });

                      case 5:
                        data = _context5.sent;
                        usr.data.avatar = data.src;
                        avatar = usr.data.avatar;
                        _context5.next = 10;
                        return myApp.user(usr);

                      case 10:
                        $update();
                        _context5.next = 13;
                        return storeAvatar(old);

                      case 13:
                        _context5.next = 18;
                        break;

                      case 15:
                        _context5.prev = 15;
                        _context5.t0 = _context5["catch"](1);
                        $f7.alertError(_context5.t0);

                      case 18:
                        _context5.prev = 18;
                        $f7.preloader.hide();
                        return _context5.finish(18);

                      case 21:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[1, 15, 18, 21]]);
              }));

              return function rotateAvatar() {
                return _ref7.apply(this, arguments);
              };
            }();

            storeAvatar = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(toDelete) {
                var b64;
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return $f7.fetchImage(usr.data.avatar);

                      case 2:
                        b64 = _context6.sent;

                        if (!b64) {
                          _context6.next = 7;
                          break;
                        }

                        _context6.next = 6;
                        return myStorage.set(usr.data.avatar, b64);

                      case 6:
                        if (toDelete) myStorage.deleteItem(toDelete);

                      case 7:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              }));

              return function storeAvatar(_x3) {
                return _ref8.apply(this, arguments);
              };
            }();
            /*
             * Apre Action Sheet ed imposta avatar
             * 
             * Usa cordova-plugin-camera
             * https://github.com/apache/cordova-plugin-camera
             * 
             */


            setAvatar = function setAvatar(setAndSave) {
              if (setAndSave !== true && $(setAndSave.target).hasClass('f7-icons')) {
                return;
              }

              if (myApp.device.cordova) {
                $f7.actions.create({
                  buttons: [{
                    label: true,
                    text: lng.image_select_source,
                    color: 'gray'
                  }, {
                    icon: '<i class="icon f7-icons">camera</i>',
                    text: lng.camera,
                    color: 'blue',
                    onClick: function () {
                      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
                        var old, data;
                        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                          while (1) {
                            switch (_context7.prev = _context7.next) {
                              case 0:
                                if (!$f7.device.android) {
                                  _context7.next = 6;
                                  break;
                                }

                                _context7.next = 3;
                                return myApp.cordova.cameraAndroidCrop();

                              case 3:
                                avatar = _context7.sent;
                                _context7.next = 9;
                                break;

                              case 6:
                                _context7.next = 8;
                                return myApp.cordova.camera({
                                  front: true,
                                  allowEdit: true,
                                  correctOrientation: true
                                });

                              case 8:
                                avatar = _context7.sent;

                              case 9:
                                $f7.preloader.show();
                                _context7.prev = 10;
                                old = usr.data.avatar;
                                _context7.next = 14;
                                return myApp.server.postJSON('user/me/avatar', {
                                  img: avatar,
                                  children: null
                                });

                              case 14:
                                data = _context7.sent;
                                usr.data.avatar = data.src;
                                _context7.next = 18;
                                return myApp.user(usr);

                              case 18:
                                $update();
                                if (setAndSave === true) save();
                                _context7.next = 22;
                                return myStorage.set(data.src, avatar);

                              case 22:
                                myStorage.deleteItem(old);
                                _context7.next = 28;
                                break;

                              case 25:
                                _context7.prev = 25;
                                _context7.t0 = _context7["catch"](10);
                                $f7.alertError(_context7.t0);

                              case 28:
                                _context7.prev = 28;
                                $f7.preloader.hide();
                                return _context7.finish(28);

                              case 31:
                              case "end":
                                return _context7.stop();
                            }
                          }
                        }, _callee7, null, [[10, 25, 28, 31]]);
                      }));

                      function onClick() {
                        return _onClick.apply(this, arguments);
                      }

                      return onClick;
                    }()
                  }, {
                    icon: '<i class="icon f7-icons">photo_on_rectangle</i>',
                    text: lng.gallery,
                    color: 'blue',
                    onClick: function () {
                      var _onClick2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                        var old, data;
                        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                          while (1) {
                            switch (_context8.prev = _context8.next) {
                              case 0:
                                if (!$f7.device.android) {
                                  _context8.next = 6;
                                  break;
                                }

                                _context8.next = 3;
                                return myApp.cordova.cameraAndroidCrop(true);

                              case 3:
                                avatar = _context8.sent;
                                _context8.next = 9;
                                break;

                              case 6:
                                _context8.next = 8;
                                return myApp.cordova.camera({
                                  allowEdit: true,
                                  gallery: true,
                                  correctOrientation: true
                                });

                              case 8:
                                avatar = _context8.sent;

                              case 9:
                                $f7.preloader.show();
                                _context8.prev = 10;
                                old = usr.data.avatar;
                                _context8.next = 14;
                                return myApp.server.postJSON('user/me/avatar', {
                                  img: avatar,
                                  children: null
                                });

                              case 14:
                                data = _context8.sent;
                                usr.data.avatar = data.src;
                                _context8.next = 18;
                                return myApp.user(usr);

                              case 18:
                                $update();
                                if (setAndSave === true) save();
                                _context8.next = 22;
                                return myStorage.set(data.src, avatar);

                              case 22:
                                myStorage.deleteItem(old);
                                _context8.next = 28;
                                break;

                              case 25:
                                _context8.prev = 25;
                                _context8.t0 = _context8["catch"](10);
                                $f7.alertError(_context8.t0);

                              case 28:
                                _context8.prev = 28;
                                $f7.preloader.hide();
                                return _context8.finish(28);

                              case 31:
                              case "end":
                                return _context8.stop();
                            }
                          }
                        }, _callee8, null, [[10, 25, 28, 31]]);
                      }));

                      function onClick() {
                        return _onClick2.apply(this, arguments);
                      }

                      return onClick;
                    }()
                  }, {
                    text: lng.cancel,
                    color: 'red'
                  }]
                }).open();
              } else {
                var fileInput = document.getElementById('imageDialogId');

                var openFileDialog = function openFileDialog() {
                  return fileInput.click();
                };

                fileInput.onchange = function (ev) {
                  var file = ev.target.files[0];
                  var reader = new FileReader();
                  reader.readAsDataURL(file);

                  reader.onload = function () {
                    avatar = reader.result;

                    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                      var old, data;
                      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                        while (1) {
                          switch (_context9.prev = _context9.next) {
                            case 0:
                              old = usr.data.avatar;
                              _context9.next = 3;
                              return myApp.server.postJSON('user/me/avatar', {
                                img: avatar,
                                children: null
                              });

                            case 3:
                              data = _context9.sent;
                              usr.data.avatar = data.src;
                              $update();
                              _context9.next = 8;
                              return myApp.user(usr);

                            case 8:
                              if (setAndSave === true) save();
                              _context9.next = 11;
                              return myStorage.set(data.src, avatar);

                            case 11:
                              myStorage.deleteItem(old);

                            case 12:
                            case "end":
                              return _context9.stop();
                          }
                        }
                      }, _callee9);
                    }))();
                  };

                  reader.onerror = function (error) {
                    console.log('Error: ', error);
                  };
                };

                openFileDialog();
              }
            };
            /*
             * Associa card tramite qrscan
             * @returns {undefined}
             */


            qrscan = /*#__PURE__*/function () {
              var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                var success, result;
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        success = /*#__PURE__*/function () {
                          var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(result) {
                            var data;
                            return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                              while (1) {
                                switch (_context10.prev = _context10.next) {
                                  case 0:
                                    if (result.text) {
                                      _context10.next = 2;
                                      break;
                                    }

                                    return _context10.abrupt("return");

                                  case 2:
                                    if (!result.text.match(myApp.qrscanpattern)) {
                                      _context10.next = 23;
                                      break;
                                    }

                                    $f7.preloader.show();
                                    _context10.prev = 4;
                                    _context10.next = 7;
                                    return myApp.server.putJSON('user/me/cardnumber?children=', result);

                                  case 7:
                                    data = _context10.sent;
                                    $f7.toast.show({
                                      text: lng.associate_card_ok_message,
                                      cssClass: 'bg-color-green text-color-white',
                                      closeTimeout: 3000
                                    });
                                    usr.cardnumber = data.cardnumber;
                                    _context10.next = 12;
                                    return myApp.user(usr);

                                  case 12:
                                    $update();
                                    _context10.next = 18;
                                    break;

                                  case 15:
                                    _context10.prev = 15;
                                    _context10.t0 = _context10["catch"](4);
                                    $f7.alertError(_context10.t0);

                                  case 18:
                                    _context10.prev = 18;
                                    $f7.preloader.hide();
                                    return _context10.finish(18);

                                  case 21:
                                    _context10.next = 24;
                                    break;

                                  case 23:
                                    $f7.dialog.alert(lng.card_cannot_be_associated);

                                  case 24:
                                  case "end":
                                    return _context10.stop();
                                }
                              }
                            }, _callee10, null, [[4, 15, 18, 21]]);
                          }));

                          return function success(_x4) {
                            return _ref11.apply(this, arguments);
                          };
                        }();

                        if (!$f7.device.cordova) {
                          _context11.next = 7;
                          break;
                        }

                        _context11.next = 4;
                        return myApp.cordova.qrscan();

                      case 4:
                        _context11.t0 = _context11.sent;
                        _context11.next = 10;
                        break;

                      case 7:
                        _context11.next = 9;
                        return $f7.pwaQrcodeScanner();

                      case 9:
                        _context11.t0 = _context11.sent;

                      case 10:
                        result = _context11.t0;
                        success(result);

                      case 12:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));

              return function qrscan() {
                return _ref10.apply(this, arguments);
              };
            }();
            /*
             * Salva
             */


            save = /*#__PURE__*/function () {
              var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                var inputsvalid, avatarvalid, sexvalid, cardOK, page;
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        inputsvalid = $f7.input.validateInputs('#validate');
                        avatarvalid = true; // avatar !== 'static/avatar.svg';

                        sexvalid = true; // $('#sex').val() !== '-';

                        cardOK = true; // Controlla campi richiesti

                        if (!(inputsvalid && avatarvalid && sexvalid && cardOK)) {
                          _context12.next = 26;
                          break;
                        }

                        $f7.preloader.show();
                        _context12.prev = 6;
                        // invia al server
                        console.log(usr.data);
                        _context12.next = 10;
                        return myApp.server.postJSON('user/me', {
                          usr: usr.data,
                          children: null
                        });

                      case 10:
                        _context12.next = 12;
                        return myApp.user(usr);

                      case 12:
                        // imposta myApp.userLoggedIn
                        userLoggedIn = true; // Mostra messaggio OK

                        $f7.toast.show({
                          text: lng.saved_ok,
                          cssClass: 'bg-color-green text-color-white',
                          closeTimeout: 3000
                        }); // Reindirizza alla pagina dei servizi oppure alla pagina ICE

                        page = usr.data.ice ? '/services/' : '/ice/?showNext=yes';
                        window.setTimeout(function () {
                          return $f7router.navigate(page);
                        }, 1500);
                        _context12.next = 21;
                        break;

                      case 18:
                        _context12.prev = 18;
                        _context12.t0 = _context12["catch"](6);
                        $f7.alertError(_context12.t0);

                      case 21:
                        _context12.prev = 21;
                        $f7.preloader.hide();
                        return _context12.finish(21);

                      case 24:
                        _context12.next = 27;
                        break;

                      case 26:
                        if (inputsvalid && sexvalid && cardOK) {
                          // Dati completi ma senza immagine -> Apre procedura per caricare l'immagine
                          // Prima mostra popup
                          $f7.dialog.alert(lng.noAvatarErrorMessage, function () {
                            return setAvatar(true);
                          });
                        } else if (inputsvalid && sexvalid) {
                          // Dati completi ma senza card -> Apre procedura per caricare card
                          qrscan();
                        } else {
                          // Dati incompleti -> mostra messaggio
                          $f7.toast.show({
                            text: lng.all_fields_are_required_message,
                            cssClass: 'bg-color-red text-color-white',
                            closeTimeout: 3000
                          });
                        }

                      case 27:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12, null, [[6, 18, 21, 24]]);
              }));

              return function save() {
                return _ref12.apply(this, arguments);
              };
            }();

            return _context13.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">

        ${userLoggedIn && $h`
        <div class="left">
          <a href="/services/" class="link">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        `}

        <div class="title">
          <span class="padding-left"> ${lng.me_title} </span>
        </div>

        <div class="right padding-right-half">
          <a href="#" @click=${actionSettings}>
            <i class="f7-icons text-color-white ios-only">gear</i>
            <i class="material-icons text-color-white md-only">settings</i>
          </a>
        </div>

      </div>
    </div>
    <div class="page-content bg-color-white">

      <div class="block">
        <div class="avatar" @click=${setAvatar} style="background-image: url('${avatar}')">
          ${!avatar.match(/avatar\.svg$/) && $h `
          <i class="f7-icons text-color-red" style="border-radius: 50%; background-color: white; padding: 3px" @click="${deleteAvatar}">trash</i>
          <i class="f7-icons text-color-white float-right" style="border-radius: 50%; background-color: rgba(0,0,0,.5); padding: 3px" @click="${rotateAvatar}">crop_rotate</i>
          `}
        </div>
      </div>

      <div class="list no-hairlines-md">
        <ul id="validate">
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="name" type="text" placeholder="${lng.your_name}" required validate value=${usr.data.name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="lastname" type="text" placeholder="${lng.your_lastname}" required validate value=${usr.data.lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          ${f7.device.android && $h`
          <li class="item-content">
            <div class="item-inner text-align-center">
              <img src="static/calendar-android-1.jpg" class="margin-bottom" width="250"/>
            </div>

          </li>
          `}
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.birthdate} * 
                ${f7.device.android && $h` 
                <br/>( <strong>${lng.birthdate_tutorial} </strong> ) 
                `}
              </div> 
              <div class="item-input-wrap">
                <input @change=${updateForm} id="birthdate" type="date" placeholder="${lng.insert} ${lng.birthdate}" value="${(usr.data.birthdate||'').substring(0,10)}" />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.gender} *</div>
              <div class="item-input-wrap">
                <select @change=${updateForm} id="sex">
                  <option value="-"></option>
                  <option value="M">M</option>
                  <option value="F">F</option>
                  <option value="N">${lng.undeclared}</option>
                </select>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.address}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="address" value="${usr.data.address}" type="text" placeholder="${lng.insert} ${lng.address}" />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.postal_code}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="cap" type="tel" placeholder="${lng.postal_code}" value=${usr.data.cap}/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.city}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="city" type="text" placeholder="${lng.insert} ${lng.city}" value="${usr.data.city}"/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="row">
              <div class="col-40">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.prov}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="district" type="text" placeholder="${lng.prov}" value="${usr.data.district}"/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-60">
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">${lng.nation}</div>
                    <div class="item-input-wrap">
                      <input @change=${updateForm} id="country" type="text" placeholder="${lng.nation}" value="${usr.data.country}"/>
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm}  class='text-upper' id="cf" type="text" placeholder="${lng.tax_id_code}" value="${usr.data.cf}"/>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>


          ${viewTutors && $h`
          <h4 class="margin-left">${lng.parent} 1</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent1_name" type="text" placeholder="${lng.insert} ${lng.name}" required validate value=${usr.data.parent1_name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent1_lastname" type="text" placeholder="${lng.insert} ${lng.lastname}" required validate value=${usr.data.parent1_lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} class='text-upper' id="parent1_cf" type="text" placeholder="${lng.insert} ${lng.tax_id_code}" value=${usr.data.parent1_cf} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <h4 class="margin-left">${lng.parent} 2</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 2 ${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent2_name" type="text" placeholder="${lng.insert} ${lng.name}" required validate value=${usr.data.parent2_name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 2 ${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="parent2_lastname" type="text" placeholder="${lng.insert} ${lng.lastname}" required validate value=${usr.data.parent2_lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.parent} 1 ${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} class='text-upper' id="parent2_cf" type="text" placeholder="${lng.insert} ${lng.tax_id_code}" value=${usr.data.parent2_cf} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          <h4 class="margin-left">Tutore</h4>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tutor} ${lng.name} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="tutor_name" type="text" placeholder="${lng.insert} ${lng.name}" required validate value=${usr.data.tutor_name} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input item-input-with-info">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tutor} ${lng.lastname} *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="tutor_lastname" type="text" placeholder="${lng.insert} ${lng.lastname}" required validate value=${usr.data.tutor_lastname} />
                <span class="input-clear-button"></span>
                <div class="item-input-info">${lng.field_required}</div>
              </div>
            </div>
          </li>
          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.tutor} ${lng.tax_id_code}</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} class='text-upper' id="tutor_cf" type="text" placeholder="${lng.insert} ${lng.tax_id_code}" value=${usr.data.tutor_cf} />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
          `}

        </ul>

        <div class="block">
          ${!(usr.cardnumber || '') ? $h`
          <button @click=${qrscan} class="button button-large button-outline button-round">
            <img src="static/card.png" style="position: absolute; left: 15px" width="38"/> 
            ${lng.associate_card}</button>
          ` : $h`
          <div class='display-flex justify-content-space-around align-items-center'>
            <img style='max-width: 50%' src='static/card.png' />
            <p class='text-align-right padding-left'>${lng.associate_card_message}</p>
          </div>
          `}
        </div>

        <div class="block">
          <button @click=${save} class="button button-large button-fill button-round color-secondary">
            <i class="f7-icons left">square_arrow_right</i> ${lng.save}
          </button>
        </div> 
      </div>
    </div>

    <div class="popup popup-tablet-fullscreen popup-pin display-flex justify-content-center align-items-center flex-direction-column">
      <div class="block text-align-center pin-title">
        <h3>${lng.set_pin}</h3>
        ${lng.pin_message} 
      </div>
      <div class="block text-align-center unselectable mt-0">
        <span class="pin-char" id="pin_0"></span>
        <span class="pin-char" id="pin_1"></span>
        <span class="pin-char" id="pin_2"></span>
        <span class="pin-char" id="pin_3"></span>
      </div>
      <div class="block text-align-center mt-0" style="width: 100%; max-width: 380px">
        <div class="row">
          <div class="col number-key pin" data-number="1">1</div>
          <div class="col number-key pin" data-number="2">2</div>
          <div class="col number-key pin" data-number="3">3</div>
        </div>
        <div class="row">
          <div class="col number-key pin" data-number="4">4</div>
          <div class="col number-key pin" data-number="5">5</div>
          <div class="col number-key pin" data-number="6">6</div>
        </div>
        <div class="row">
          <div class="col number-key pin" data-number="7">7</div>
          <div class="col number-key pin" data-number="8">8</div>
          <div class="col number-key pin" data-number="9">9</div>
        </div>
        <div class="row">
          <div class="col number-key pin" data-number="null"></div>
          <div class="col number-key pin" data-number="0">0</div>
          <div class="col number-key pin" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
        </div>
      </div>

      <button class='button button-large button-round button-outline invisible' 
              id="pin-btn-next" @click=${savePIN}
              style="width: 100%; max-width: 320px; height: 42px">
        <span class="padding-horizontal">${lng.next}</span>
        <i class='icon f7-icons'>arrow_right</i>
      </button>

      <button class="button button-link text-color-gray popup-close">${lng.cancel}</button>
    </div>

    <div class="popup popup-tablet-fullscreen popup-safe display-flex justify-content-center align-items-center flex-direction-column">
      <div class="block text-align-center">
        ${lng.insert_pin_message}
      </div>
      <div class="unselectable" style="width: 100%; max-width: 380px;">
        <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">
          <div class="col">
            <div class="point point-0"></div>
          </div>
          <div class="col">
            <div class="point point-1"></div>
          </div>
          <div class="col">
            <div class="point point-2"></div>
          </div>
          <div class="col">
            <div class="point point-3"></div>
          </div>
        </div>
        <div id="safe-message" class="text-align-center text-color-red invisible">
          ${lng.pin_error_message} <br/> ${lng.attempts_left}: ${safeAttempts}
        </div>
        <div class="block text-align-center">
          <div class="row">
            <div class="col number-key safe" data-number="1">1</div>
            <div class="col number-key safe" data-number="2">2</div>
            <div class="col number-key safe" data-number="3">3</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="4">4</div>
            <div class="col number-key safe" data-number="5">5</div>
            <div class="col number-key safe" data-number="6">6</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="7">7</div>
            <div class="col number-key safe" data-number="8">8</div>
            <div class="col number-key safe" data-number="9">9</div>
          </div>
          <div class="row">
            <div class="col number-key safe" data-number="null"></div>
            <div class="col number-key safe" data-number="0">0</div>
            <div class="col number-key safe" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
          </div>
        </div>
      </div>
      <button class="button button-link text-color-gray" @click=${safeCancel}>${lng.cancel}</button>
      <button class="button button-link text-color-primary" @click=${recoveryPIN}>${lng.recoveryPINMessage}</button>
    </div>

    <form style="display:none">
      <input type="file" accept="image/*" id="imageDialogId" />
    </form>

  </div>
`
    }
    );

          case 37:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();